import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHashtag,  } from '@fortawesome/free-solid-svg-icons';
import { FaInstagram, FaFacebookF, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import {useUser} from "../../contexts/UserContext";
import Routing from "../../services/routing";

function Footer() {
    const { user, setUser, loading } = useUser();

    let footerClass = `${styles.footer}`;
    // if (user && user.roles.includes("ROLE_ADMIN")) {
    //     footerClass = `${styles.footer} ${styles.footerAdmin}`;
    // }

    return (
        <footer className={footerClass}>
            <div className={styles.socialMediaSection}>
                <span>Suivez-nous</span>
                <div className={styles.socialMediaIcons}>
                    <a href={Routing.externes.instagram} target="_blank" rel="noopener noreferrer">
                        <FaInstagram />
                    </a>
                    <a href={Routing.externes.facebook} target="_blank" rel="noopener noreferrer">
                        <FaFacebookF />
                    </a>
                    <a href={Routing.externes.youtube} target="_blank" rel="noopener noreferrer">
                        <FaYoutube />
                    </a>
                    <a href={Routing.externes.linkedin} target="_blank" rel="noopener noreferrer">
                        <FaLinkedinIn />
                    </a>
                </div>
            </div>
            <div className={styles.legalSection}>
                <Link to={Routing.routes.cgu}>CONDITIONS GÉNÉRALES D'UTILISATION</Link>
                <Link to={Routing.routes.report}>Signaler un problème</Link>
            </div>
        </footer>
    );
}

export default Footer;
